import { useState, useEffect, useMemo } from 'react'
import { ProgressBar, Card } from 'react-bootstrap'
import { useQuery } from '@tanstack/react-query'
import api from '../components/api'

interface iDashboardModalidades {

    descricao: string,
    modalidade_id: number,
    percentual: number,
    total: number,

}

export default function EmissoesPorModalidade(props: any) {


    const { cliente_id, ano, mes } = props


    const { data: dados } = useQuery<iDashboardModalidades[]>({

        queryKey: ['dashboardModalidade', cliente_id, ano, mes],
        queryFn: async () => {

            try {

                const dataPost = {

                    cliente_id,
                    ano,
                    mes,

                }

                //console.log(dataPost)

                const result = await api.post<iDashboardModalidades[]>('dashboardModalidade', dataPost)
                //console.log(result.data)
                return result.data ?? []

            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },
        enabled: !!cliente_id && !!ano

    })


    const total = useMemo(() => {
        return dados?.reduce((acc: number, item: iDashboardModalidades) => acc + item.total, 0)
      }, [dados])



    const normalizado = useMemo(() => {

        if (total) {

            return dados?.map((d: iDashboardModalidades) => ({
                ...d,
                percentual: (d.total / total) * 100
              }))

        }
      
    }, [dados, total])
    
      const [animado, setAnimado] = useState<number[]>([])




      useEffect(() => {

        if (normalizado) {

            setAnimado(normalizado?.map(() => 0))

            const timer = setTimeout(() => {
                setAnimado(normalizado?.map((g: iDashboardModalidades) => g.percentual))
            }, 150)
    
            return () => clearTimeout(timer)

        }

        }, [normalizado])
    
    
    const cores = ['primary', 'success', 'warning', 'danger', 'info', 'secondary']

    return (

        <div>


                {
                    
                normalizado && (

                    <Card className="shadow-sm border-0">
                        
                        <Card.Body>
        
                        {normalizado?.map((g: iDashboardModalidades, index: number) => (
                            <div key={g.modalidade_id} className="mb-3">
        
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: 4
                            }}>
                                <span style={{ fontWeight: 600 }}>
                                {g.descricao}
                                </span>
        
                                <span style={{ fontSize: 13, color: "#6c757d" }}>
                                R$ {g.total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})} ({g.percentual.toFixed(1)}%)
                                </span>
                            </div>
        
                            <ProgressBar
                            now={animado[index] ?? 0}
                            variant={cores[index % cores.length]}
                            label={`${g.percentual.toFixed(1)}%`}
                            style={{
                                height: 18,
                                borderRadius: 6,
                                transition: "all 0.8s ease",
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#fff"
                            }}
                            />
        
                            </div>
                        ))}
        
                        <hr />
        
                        <div className="d-flex justify-content-between fw-bold">
                            <span>Total</span>
                            <span>R$ {total?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                        </div>
        
                        </Card.Body>
                    </Card>

                )

            }



        </div>

    )

}